function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable react/forbid-prop-types */

/* eslint-disable react/no-unused-prop-types */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable default-case */

/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { any, node, string } from 'prop-types';
import cn from 'classnames';
import styles from './sideDrawer.scss';
import Heading from '../heading/Heading';
import IconChevronLeft from './assets/IconChevronLeft';
import IconClose from './assets/IconClose';
/* istanbul ignore next */

var SideDrawer = function SideDrawer(_ref) {
  var children = _ref.children,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      trigger = _ref.trigger,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsId = _ref$dataAnalyticsId === void 0 ? undefined : _ref$dataAnalyticsId,
      _ref$dataAnalyticsLab = _ref.dataAnalyticsLabel,
      dataAnalyticsLabel = _ref$dataAnalyticsLab === void 0 ? undefined : _ref$dataAnalyticsLab;

  var _useState = useState('menu'),
      _useState2 = _slicedToArray(_useState, 2),
      style = _useState2[0],
      setStyle = _useState2[1];

  var _useState3 = useState('open'),
      _useState4 = _slicedToArray(_useState3, 2),
      menuStatus = _useState4[0],
      setMenuStatus = _useState4[1];

  var handleClick = function handleClick() {
    switch (menuStatus) {
      case 'open':
        setMenuStatus('close');
        setStyle('active');
        break;

      case 'close':
        setMenuStatus('open');
        setStyle('');
        break;
    }
  };

  var sideDrawerStyles = styles['side-drawer'];
  return /*#__PURE__*/React.createElement("div", {
    className: cn(sideDrawerStyles, 'side-drawer', className),
    "data-analytics-id": dataAnalyticsId,
    "data-analytics-label": dataAnalyticsLabel,
    "data-test-id": "side-drawer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "trigger",
    "data-test-id": "trigger",
    onClick: handleClick
  }, trigger), /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    "data-test-id": style === 'active' ? "overlay ".concat(style) : 'overlay',
    className: style === 'active' ? "overlay ".concat(style) : 'overlay'
  }), /*#__PURE__*/React.createElement("div", {
    "data-test-id": style === 'active' ? "menu ".concat(style) : 'menu',
    className: style === 'active' ? "menu ".concat(style) : 'menu'
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper-header"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-chevron-left",
    "data-test-id": "icon-chevron-left",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(IconChevronLeft, null)), title !== null ? /*#__PURE__*/React.createElement(Heading, {
    color: "#ffffff",
    variant: 6
  }, /*#__PURE__*/React.createElement(React.Fragment, null, title)) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("i", {
    className: "icon-close",
    "data-test-id": "icon-close",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(IconClose, null))), /*#__PURE__*/React.createElement("div", {
    className: "wrapper-content"
  }, children)));
};

SideDrawer.propTypes = {
  className: string,
  dataAnalyticsLabel: string,
  dataAnalyticsId: string,
  title: string,
  children: node.isRequired,
  trigger: any.isRequired
};
export default SideDrawer;